export const SET_IS_LOADING = "RESOURCES/SET_IS_LOADING";
export const SET_RESOURCE_LIST = "RESOURCES/SET_RESOURCE_LIST";
export const RESOURCE_LIST_ADD_ITEM = "RESOUCE_LIST_ADD_ITEM";
export const RESOURCE_LIST_UPDATE_ITEM = "RESOURCE_LIST_UPDATE_ITEM";
